"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Generates an onChange method for a Redux Form input that allows an external hook.
 * @param {Function} onChange - The Redux Form onChange handler.
 * @param {Function} [onChangeHook=null] - The onChange hook.
 * @returns {Function} The onChange handler for the form input.
 */
exports.default = function (onChange) {
  var onChangeHook = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (event) {
    onChange(event);

    if (onChangeHook) {
      setTimeout(onChangeHook);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/helpers/onChangeHookGenerator.js
// module id = 275
// module chunks = 0